// extracted by mini-css-extract-plugin
export default {"rating":"rJ-z","numberOfStars":"sJ-z","count":"tJ-z","barGraphSpacing":"uJ-z","barGraph":"vJ-z"};